import React from 'react'
import { useState } from "react";
import { Form } from "semantic-ui-react";
import { FormErrorHeader } from '../generic/form-error-header';
import { InputField } from '../generic/input-field';
import InformationBandeau from '../generic/information-bandeau/information-bandeau';
import { NaturalUserWithScaResponse, UserInfoResponse } from '../../model/dto/response';
import { RegisterTelBody } from '../../model/dto/body/register-tel-body';
import { SubmitButton } from '../generic/submit-button';
import { userService } from '../../services/authentication-redux-service';
import { AuthenticationState } from '../../model/state/authentication-state';
import { ApplicationState } from '../../store';
import { useSelector } from 'react-redux';
import { SimpleButton } from '../generic/simple-button';
import { StatutSca } from '../../model/entities/statut-sca';

type Props = {
  userInfo?: UserInfoResponse;
  isOnboarding?: boolean;
  onActionSuccess: (response : NaturalUserWithScaResponse) => void
  onSkipAction?: () => void
}

type TelFieldData = {
  value?: string;
  name?: string;
  isValid?: boolean;
};

type TelForm = {
  tel : TelFieldData
}

export default function SubscriptionTelForm({userInfo, isOnboarding, onActionSuccess, onSkipAction}: Props) {
  const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)
  const [isFormError, setIsFormError] = useState(false);
  const validateMandatory = (value: any): boolean => {
    return value && value !== "";
  };

  const [form, setForm] = useState<TelForm>({
  tel: {
    value : userInfo?.Tel,
    name: "tel",
    isValid : true
  }
  })

  const handleInputTelChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName?: string,
    isValid?: boolean): void => {
      const fieldValue = e.target.value;
      const newField: TelFieldData = {
        [fieldName!]: { value: fieldValue, name: fieldName, isValid: isValid },
      };
      
      setForm({...form,...newField});
      setIsFormError(false);
  }

  const body: RegisterTelBody = {
    TelNumber: form.tel.value
  }

  const onFormNotValid = (): void => {
    setIsFormError(true);
  };

  const isFormValid = () => {
    return validateMandatory(form.tel.value)
  }

  const scaAlreadyValidatedMessage = `Vos informations sont à jour et votre numéro est bien vérifié. Vous n’avez pas besoin d’effectuer une nouvelle demande de vérification à ce jour. 
  Bien sûr, vous avez toujours la possibilité d’enregistrer un autre numéro à tout moment. Toutefois, cela nécessitera de devoir à nouveau faire l'étape de vérification du compte avec ce nouveau numéro. Tant que cela ne sera pas fait, vous ne serez plus en mesure d’investir dans un projet ou de faire des retraits de votre solde, la bonne vérification de votre compte étant une condition essentielle au préalable pour réaliser ces actions là.`

  const standardScaMessage = `Votre numéro de téléphone restera confidentiel et utilisé uniquement pour sécuriser votre compte.`

  return (
    <Form>
      <FormErrorHeader
        message="Veuillez corriger les champs en erreur"
        displayed={isFormError}
      />
      <InformationBandeau 
        type="information"
        icon={{name:'info circle', size:"big", color:"blue"}}
        message={userInfo?.StatutScaCode === StatutSca.VALIDE ? scaAlreadyValidatedMessage : standardScaMessage}
      />
      <InputField
        label='Numéro de téléphone' 
        data={form.tel} 
        type="tel"
        onChange={handleInputTelChange}    
        inputCss={'max-width: 150px'}
      />
      <div style={{marginTop: 20, display: 'flex'}}>
        {userInfo?.IsAdressePostaleDone && userInfo.IsIdentiteDone && 
        <SubmitButton
          data={body}
          action={() => {return userService.registerTel(body, loginProps?.oauth?.userId, loginProps?.oauth)}}
          label='Valider mon numéro'
          validateForm={isFormValid}
          onFormNotValid={onFormNotValid}
          onActionSuccess={onActionSuccess}
          debounceTimming={isOnboarding ? 1000 : undefined}
        />
        }
        <SimpleButton
          label={isOnboarding ? "Faire cette étape plus tard" : "Annuler"}
          onClick={onSkipAction}
        />
      </div>        
    </Form>
  )
}
